/**
 * LomloeRadarChart - Generador de Gráficos Radar SVG de Competencias LOMLOE
 * Inspirado en Innovamat / Analytics para Profesores y Familias
 */

export class LomloeRadarChartManager {
    /**
     * Dibuja un gráfico Radar SVG interactivo dentro de un contenedor HTML
     * @param {string} containerId - ID del elemento contenedor
     * @param {object} scores - Puntuaciones de 0 a 100 por eje competencial
     */
    renderChart(containerId, scores = {}) {
        const container = document.getElementById(containerId);
        if (!container) return;

        const defaultScores = {
            comprehension: 85,
            representation: 90,
            reasoning: 75,
            calculation: 95,
            communication: 80
        };

        const data = Object.assign({}, defaultScores, scores);

        const categories = [
            { key: 'comprehension', label: 'Comprensión' },
            { key: 'representation', label: 'Representación' },
            { key: 'reasoning', label: 'Razonamiento' },
            { key: 'calculation', label: 'Cálculo ABN' },
            { key: 'communication', label: 'Comunicación' }
        ];

        const size = 300;
        const center = size / 2;
        const radius = 95;
        const numAxes = categories.length;
        const angleStep = (2 * Math.PI) / numAxes;

        // Calcular puntos para cada nivel concéntrico (20%, 40%, 60%, 80%, 100%)
        let gridLines = '';
        for (let level = 1; level <= 5; level++) {
            const r = (radius / 5) * level;
            const points = [];
            for (let i = 0; i < numAxes; i++) {
                const angle = i * angleStep - Math.PI / 2;
                const x = center + r * Math.cos(angle);
                const y = center + r * Math.sin(angle);
                points.push(`${x},${y}`);
            }
            gridLines += `<polygon points="${points.join(' ')}" fill="none" stroke="#e2e8f0" stroke-width="1.2" stroke-dasharray="${level === 5 ? '0' : '3,3'}" />`;
        }

        // Ejes radiales y etiquetas
        let axesAndLabels = '';
        const dataPoints = [];

        categories.forEach((cat, i) => {
            const angle = i * angleStep - Math.PI / 2;
            const x2 = center + radius * Math.cos(angle);
            const y2 = center + radius * Math.sin(angle);

            // Eje
            axesAndLabels += `<line x1="${center}" y1="${center}" x2="${x2}" y2="${y2}" stroke="#cbd5e1" stroke-width="1.5" />`;

            // Posición del dato del alumno (0-100%)
            const scoreVal = Math.min(100, Math.max(0, data[cat.key] || 0));
            const rData = (radius * scoreVal) / 100;
            const xData = center + rData * Math.cos(angle);
            const yData = center + rData * Math.sin(angle);
            dataPoints.push(`${xData},${yData}`);

            // Posición de la etiqueta externa
            const xLabel = center + (radius + 22) * Math.cos(angle);
            const yLabel = center + (radius + 15) * Math.sin(angle);
            const anchor = Math.abs(Math.cos(angle)) < 0.1 ? 'middle' : (Math.cos(angle) > 0 ? 'start' : 'end');

            axesAndLabels += `
                <text x="${xLabel}" y="${yLabel}" text-anchor="${anchor}" font-size="11" font-weight="600" fill="#334155">
                    ${cat.label} (${scoreVal}%)
                </text>
            `;
        });

        // Polígono del área de rendimiento del alumno
        const polygonArea = `
            <polygon points="${dataPoints.join(' ')}" 
                     fill="rgba(59, 130, 246, 0.35)" 
                     stroke="#2563eb" 
                     stroke-width="2.5" 
                     stroke-linejoin="round" />
        `;

        // Puntos de los vértices
        let vertexCircles = '';
        dataPoints.forEach(pt => {
            const [x, y] = pt.split(',');
            vertexCircles += `<circle cx="${x}" cy="${y}" r="4" fill="#1d4ed8" stroke="#ffffff" stroke-width="2" />`;
        });

        const svgHTML = `
            <div class="lomloe-radar-wrapper" style="text-align: center; background: #ffffff; padding: 15px; border-radius: 16px; border: 1px solid #e2e8f0; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                <h4 style="margin: 0 0 10px 0; font-size: 1rem; color: #1e293b; display: flex; align-items: center; justify-content: center; gap: 6px;">
                    🎯 <span>Evaluación Competencial LOMLOE</span>
                </h4>
                <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" style="max-width: 100%; height: auto;">
                    ${gridLines}
                    ${axesAndLabels}
                    ${polygonArea}
                    ${vertexCircles}
                </svg>
            </div>
        `;

        container.innerHTML = svgHTML;
    }
}

export const LomloeRadarChart = new LomloeRadarChartManager();

if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.LomloeRadarChart = LomloeRadarChart;
    window.LomloeRadarChart = LomloeRadarChart;
}
